var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginRegisterBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1299.988,
    height: 377.267,
    viewBox: "0 0 1299.988 377.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18312",
    "data-name": "Group 18312",
    transform: "translate(0 -702.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18205",
    "data-name": "Group 18205",
    transform: "translate(-1639.105 1610.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M575.837,155.623v-40H551.791v40H523.316V93.749H502.434V47.5H485.349V0H449.913V47.5H432.827V93.749H412.578V38.125h-11.39V10h-6.961V38.125h-40.5v177.5H322.722v-18.75H303.738v18.75H272.732v-60H217.046v-40H193v40h-1.266V232.5H166.423v-45H136.049v45H110.738V93.749H91.122V47.5H18.984V93.749H0V338.121H604.313v-182.5Z",
    transform: "translate(2313.093 -869)",
    fill: "#047baa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 26.406,
    height: 15.089,
    transform: "translate(2325.038 -758.682)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 26.406,
    height: 15.089,
    transform: "translate(2411.459 -743.593) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 26.406,
    height: 15.089,
    transform: "translate(2325.038 -728.711)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 26.406,
    height: 15.089,
    transform: "translate(2411.459 -713.622) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 26.406,
    height: 15.089,
    transform: "translate(2325.038 -698.741)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 26.406,
    height: 15.089,
    transform: "translate(2411.459 -683.652) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 26.406,
    height: 15.089,
    transform: "translate(2325.038 -668.77)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 26.406,
    height: 15.089,
    transform: "translate(2411.459 -653.681) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 26.406,
    height: 15.089,
    transform: "translate(2325.038 -638.799)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 26.406,
    height: 15.089,
    transform: "translate(2411.459 -623.71) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 26.406,
    height: 15.089,
    transform: "translate(2325.038 -608.828)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 26.406,
    height: 15.089,
    transform: "translate(2411.459 -593.739) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 26.406,
    height: 15.089,
    transform: "translate(2325.038 -579.062)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 26.406,
    height: 15.089,
    transform: "translate(2411.459 -563.973) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 61.614,
    height: 7.545,
    transform: "translate(2433.819 -616.542)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 61.614,
    height: 7.545,
    transform: "translate(2433.819 -605.067)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 61.614,
    height: 7.545,
    transform: "translate(2433.819 -593.927)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 61.614,
    height: 7.545,
    transform: "translate(2595.775 -612.717)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 61.614,
    height: 7.545,
    transform: "translate(2595.775 -601.242)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 61.614,
    height: 7.545,
    transform: "translate(2595.775 -590.079)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 61.614,
    height: 7.545,
    transform: "translate(2433.819 -582.382)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 61.614,
    height: 7.545,
    transform: "translate(2433.819 -570.837)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 61.614,
    height: 7.545,
    transform: "translate(2433.819 -559.292)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 16.975,
    height: 22.005,
    transform: "translate(2518.472 -695.512)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 16.975,
    height: 22.005,
    transform: "translate(2572.758 -673.507) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 16.975,
    height: 22.005,
    transform: "translate(2518.472 -659.794)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 16.975,
    height: 22.005,
    transform: "translate(2572.758 -637.789) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 16.975,
    height: 22.005,
    transform: "translate(2518.472 -624.076)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 16.975,
    height: 22.005,
    transform: "translate(2572.758 -602.071) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 16.975,
    height: 22.005,
    transform: "translate(2518.472 -588.583)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 16.975,
    height: 22.005,
    transform: "translate(2572.758 -566.578) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 22.634,
    height: 28.921,
    transform: "translate(2667.104 -816.53)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 22.634,
    height: 28.921,
    transform: "translate(2667.104 -773.303)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 22.634,
    height: 28.921,
    transform: "translate(2667.104 -731.197)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 22.634,
    height: 28.921,
    transform: "translate(2667.104 -689.091)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 22.634,
    height: 28.921,
    transform: "translate(2667.104 -646.984)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 22.634,
    height: 28.921,
    transform: "translate(2667.104 -605.171)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 84.247,
    height: 24.52,
    transform: "translate(2739.794 -755.458)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 84.247,
    height: 24.52,
    transform: "translate(2740.109 -701.876)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 84.247,
    height: 24.52,
    transform: "translate(2740.424 -648.294)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 84.247,
    height: 24.52,
    transform: "translate(2740.738 -594.964)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 11.317,
    height: 23.891,
    transform: "translate(2331.954 -807.127)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 28.292,
    height: 36.465,
    transform: "translate(2889.113 -695.423)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 28.292,
    height: 36.465,
    transform: "translate(2889.113 -641.819)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 28.292,
    height: 36.465,
    transform: "translate(2889.113 -588.353)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(2721.959 -659.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M159.132,585.166s-30.583,18.452,25.794,46.859c0,0,12.431-23.059-1.313-41.86a18.514,18.514,0,0,0-24.018-5.264Z",
    transform: "translate(-150.851 -504.141)",
    fill: "#01a09b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M173.08,588.3s26.17,20.025,25.44,47.248",
    transform: "translate(-164.012 -507.664)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M236.291,549.1s-9.583-32.537,1.8-56.485a51.38,51.38,0,0,0,4.156-32.242,86.43,86.43,0,0,0-4.564-15.15",
    transform: "translate(-200.242 -420.164)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M241.26,394.678c0,3.989-7.221,15.538-7.221,15.538s-7.221-11.564-7.221-15.538a7.221,7.221,0,1,1,14.439,0Z",
    transform: "translate(-196.762 -387.288)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M271.913,445.857c-2.168,3.349-14.513,9.129-14.513,9.129s.225-13.631,2.393-16.979a7.221,7.221,0,0,1,12.12,7.847Z",
    transform: "translate(-215.395 -416.011)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M266.435,538.821c-3.562,1.795-17.135.555-17.135.555s7.074-11.654,10.636-13.448a7.221,7.221,0,1,1,6.5,12.894Z",
    transform: "translate(-210.451 -470.555)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M249.4,613.121c-3.2,2.37-16.8,3.442-16.8,3.442s5-12.679,8.208-15.053a7.221,7.221,0,1,1,8.589,11.611Z",
    transform: "translate(-200.279 -515.74)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M214.732,468.944c2.859,2.777,16.187,5.656,16.187,5.656s-3.263-13.235-6.122-16.016a7.221,7.221,0,1,0-10.061,10.356Z",
    transform: "translate(-187.988 -429.041)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M192.651,553.111c3.562,1.795,17.135.555,17.135.555s-7.074-11.654-10.636-13.448a7.221,7.221,0,1,0-6.5,12.894Z",
    transform: "translate(-173.518 -479.177)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M186.845,640.281c3.2,2.37,16.8,3.442,16.8,3.442s-5-12.683-8.212-15.053a7.221,7.221,0,1,0-8.589,11.611Z",
    transform: "translate(-170.619 -531.486)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M241.26,394.678c0,3.989-7.221,15.538-7.221,15.538s-7.221-11.564-7.221-15.538a7.221,7.221,0,1,1,14.439,0Z",
    transform: "translate(-196.762 -387.288)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M271.913,445.857c-2.168,3.349-14.513,9.129-14.513,9.129s.225-13.631,2.393-16.979a7.221,7.221,0,0,1,12.12,7.847Z",
    transform: "translate(-215.395 -416.011)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M266.435,538.821c-3.562,1.795-17.135.555-17.135.555s7.074-11.654,10.636-13.448a7.221,7.221,0,1,1,6.5,12.894Z",
    transform: "translate(-210.451 -470.555)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M249.4,613.121c-3.2,2.37-16.8,3.442-16.8,3.442s5-12.679,8.208-15.053a7.221,7.221,0,1,1,8.589,11.611Z",
    transform: "translate(-200.279 -515.74)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M214.732,468.944c2.859,2.777,16.187,5.656,16.187,5.656s-3.263-13.235-6.122-16.016a7.221,7.221,0,1,0-10.061,10.356Z",
    transform: "translate(-187.988 -429.041)",
    fill: "#5ec5c1",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M192.651,553.111c3.562,1.795,17.135.555,17.135.555s-7.074-11.654-10.636-13.448a7.221,7.221,0,1,0-6.5,12.894Z",
    transform: "translate(-173.518 -479.177)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M186.845,640.281c3.2,2.37,16.8,3.442,16.8,3.442s-5-12.683-8.212-15.053a7.221,7.221,0,1,0-8.589,11.611Z",
    transform: "translate(-170.619 -531.486)",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(2876.989 -703.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M1007.606,562.294s-12.8-43.446,2.4-75.423a68.6,68.6,0,0,0,5.55-43.052,115.4,115.4,0,0,0-6.094-20.229",
    transform: "translate(-977.363 -389.89)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M1016.192,375.526c0,5.327-9.643,20.748-9.643,20.748s-9.643-15.442-9.643-20.748a9.643,9.643,0,1,1,19.28,0Z",
    transform: "translate(-974.636 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M1046.828,427.538c-2.894,4.471-19.379,12.189-19.379,12.189s.3-18.2,3.2-22.672a9.643,9.643,0,1,1,16.183,10.478Z",
    transform: "translate(-989.338 -387.688)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M1042.24,521.774c-4.756,2.4-22.88.742-22.88.742s9.445-15.561,14.2-17.957a9.642,9.642,0,1,1,8.684,17.217Z",
    transform: "translate(-985.444 -430.612)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M1025.088,595.859c-4.279,3.164-22.428,4.6-22.428,4.6s6.681-16.93,10.96-20.1a9.642,9.642,0,1,1,11.468,15.5Z",
    transform: "translate(-977.406 -465.823)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M985.707,451.633c3.818,3.709,21.614,7.552,21.614,7.552s-4.357-17.672-8.175-21.386a9.643,9.643,0,1,0-13.439,13.834Z",
    transform: "translate(-967.84 -398.362)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M964.279,536.165c4.756,2.4,22.88.742,22.88.742s-9.446-15.561-14.2-17.957a9.643,9.643,0,0,0-8.678,17.215Z",
    transform: "translate(-956.485 -437.435)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M957.883,623.019c4.279,3.164,22.429,4.6,22.429,4.6s-6.681-16.93-10.96-20.1a9.642,9.642,0,1,0-11.469,15.5Z",
    transform: "translate(-953.974 -478.597)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(2699.452 -643.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M901.8,629.507s8.337-28.292-1.566-49.127a44.7,44.7,0,0,1-3.615-28.041,75.165,75.165,0,0,1,3.967-13.159",
    transform: "translate(-881.281 -517.003)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M892.72,514.517c0,3.47,6.287,13.524,6.287,13.524s6.287-10.06,6.287-13.524a6.287,6.287,0,1,0-12.574,0Z",
    transform: "translate(-879.574 -508.23)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M910.321,542.919c1.886,2.911,12.624,7.941,12.624,7.941s-.195-11.857-2.081-14.768a6.287,6.287,0,1,0-10.543,6.828Z",
    transform: "translate(-907.554 -517.122)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M908.019,594.05c3.1,1.559,14.907.484,14.907.484s-6.155-10.135-9.248-11.694a6.287,6.287,0,0,0-5.658,11.216Z",
    transform: "translate(-904.8 -534.869)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M898.127,633.8c2.792,2.062,14.611,2.993,14.611,2.993s-4.351-11.028-7.142-13.09a6.287,6.287,0,0,0-7.469,10.1Z",
    transform: "translate(-888.967 -547.993)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M898.879,556c-2.515,2.414-14.077,4.923-14.077,4.923s2.836-11.512,5.325-13.926a6.287,6.287,0,1,1,8.752,9.01Z",
    transform: "translate(-870.305 -521.461)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M887.507,601.74c-3.1,1.559-14.907.484-14.907.484s6.155-10.135,9.248-11.694a6.287,6.287,0,0,1,5.659,11.216Z",
    transform: "translate(-852.356 -537.626)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M884.588,648.391c-2.791,2.062-14.611,2.993-14.611,2.993s4.376-11.034,7.142-13.1a6.287,6.287,0,0,1,7.469,10.1Z",
    transform: "translate(-846.922 -553.396)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M361.041,153.853h-4.326a3.03,3.03,0,1,0,0-6.054H321.678a3.03,3.03,0,0,0,0,6.054H326a3.03,3.03,0,1,0,0,6.054h-6.054a3.03,3.03,0,1,0,0,6.054h35.038a3.03,3.03,0,1,0,0-6.054h6.055a3.03,3.03,0,1,0,0-6.054Z",
    transform: "translate(2119.718 -992.876)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29",
    d: "M607.041,274.853h-4.325a3.03,3.03,0,1,0,0-6.055H567.678a3.03,3.03,0,0,0,0,6.055H572a3.03,3.03,0,1,0,0,6.055h-6.054a3.03,3.03,0,1,0,0,6.054h35.038a3.03,3.03,0,1,0,0-6.054h6.055a3.03,3.03,0,1,0,0-6.055Z",
    transform: "translate(2029.326 -1036.365)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-2",
    "data-name": "Path 30",
    d: "M1026.041,116.853h-4.326a3.03,3.03,0,1,0,0-6.054H986.678a3.03,3.03,0,0,0,0,6.054H991a3.03,3.03,0,1,0,0,6.054h-6.055a3.03,3.03,0,1,0,0,6.054h35.038a3.03,3.03,0,0,0,0-6.054h6.055a3.03,3.03,0,1,0,0-6.054Z",
    transform: "translate(1875.445 -979.138)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-2",
    "data-name": "Path 31",
    d: "M519.628,465.94c-.484.352-.748.547-.748.547A3.185,3.185,0,0,0,519.628,465.94Z",
    transform: "translate(2045.318 -1107.912)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-2",
    "data-name": "Path 32",
    d: "M520.558,466.88c-.484.352-.748.547-.748.547A3.188,3.188,0,0,0,520.558,466.88Z",
    transform: "translate(2044.976 -1108.253)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33",
    d: "M520.558,465.94c-.484.352-.748.547-.748.547A3.189,3.189,0,0,0,520.558,465.94Z",
    transform: "translate(2044.976 -1107.912)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(2838.951 -647.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-2",
    "data-name": "Path 46",
    d: "M1008.828,517.369s8.652-29.374-1.624-50.994a46.384,46.384,0,0,1-3.752-29.108,78.042,78.042,0,0,1,4.12-13.677",
    transform: "translate(-987.287 -400.805)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-2",
    "data-name": "Path 47",
    d: "M996.9,372.33c0,3.6,6.519,14.028,6.519,14.028s6.52-10.44,6.52-14.028a6.519,6.519,0,1,0-13.035,0Z",
    transform: "translate(-983.012 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-2",
    "data-name": "Path 48",
    d: "M1028.587,422.65c1.957,3.023,13.1,8.241,13.1,8.241s-.2-12.306-2.161-15.329a6.519,6.519,0,1,0-10.942,7.084Z",
    transform: "translate(-1025.469 -395.707)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-2",
    "data-name": "Path 49",
    d: "M1022.949,515.862c3.216,1.62,15.469.5,15.469.5s-6.386-10.521-9.6-12.141a6.519,6.519,0,1,0-5.871,11.641Z",
    transform: "translate(-1019.36 -454.227)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-2",
    "data-name": "Path 50",
    d: "M1005.3,590.225c2.893,2.139,15.164,3.107,15.164,3.107s-4.517-11.447-7.41-13.589a6.519,6.519,0,1,0-7.754,10.482Z",
    transform: "translate(-995.552 -502.307)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-2",
    "data-name": "Path 51",
    d: "M997.4,446.27c-2.581,2.508-14.614,5.106-14.614,5.106s2.946-11.948,5.527-14.459a6.52,6.52,0,1,1,9.086,9.353Z",
    transform: "translate(-967.488 -410.252)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-2",
    "data-name": "Path 52",
    d: "M974.66,530.289c-3.216,1.62-15.469.5-15.469.5s6.386-10.521,9.6-12.141a6.519,6.519,0,0,1,5.867,11.64Z",
    transform: "translate(-937.941 -463.536)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-2",
    "data-name": "Path 53",
    d: "M969.138,617.385c-2.893,2.139-15.164,3.107-15.164,3.107s4.517-11.447,7.41-13.589a6.519,6.519,0,1,1,7.754,10.482Z",
    transform: "translate(-929.792 -519.74)",
    fill: "#017572"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17447",
    "data-name": "Group 17447",
    transform: "translate(0 702.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27-2",
    "data-name": "Path 27",
    d: "M642.229,173.566V128.955H615.411v44.611H583.652V104.558h-23.29V52.976H541.308V0H501.786V52.976H482.731v51.582H460.147V42.52h-12.7V11.153H439.68V42.52H394.512V240.483H359.931V219.571H338.758v20.912H304.177V173.566H242.071V128.955H215.253v44.611h-1.411V259.3h-28.23V209.115H151.735V259.3h-28.23V104.558H101.628V52.976H21.172v51.582H0V377.1H673.988V173.566Z",
    transform: "translate(0)",
    fill: "#047baa",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15-2",
    "data-name": "Rectangle 15",
    width: 29.45,
    height: 16.829,
    transform: "translate(13.323 123.037)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-2",
    "data-name": "Rectangle 16",
    width: 29.45,
    height: 16.829,
    transform: "translate(109.708 139.866) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-2",
    "data-name": "Rectangle 17",
    width: 29.45,
    height: 16.829,
    transform: "translate(13.323 156.463)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-2",
    "data-name": "Rectangle 18",
    width: 29.45,
    height: 16.829,
    transform: "translate(109.708 173.292) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19-2",
    "data-name": "Rectangle 19",
    width: 29.45,
    height: 16.829,
    transform: "translate(13.323 189.89)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20-2",
    "data-name": "Rectangle 20",
    width: 29.45,
    height: 16.829,
    transform: "translate(109.708 206.718) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21-2",
    "data-name": "Rectangle 21",
    width: 29.45,
    height: 16.829,
    transform: "translate(13.323 223.316)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22-2",
    "data-name": "Rectangle 22",
    width: 29.45,
    height: 16.829,
    transform: "translate(109.708 240.145) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23-2",
    "data-name": "Rectangle 23",
    width: 29.45,
    height: 16.829,
    transform: "translate(13.323 256.742)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24-2",
    "data-name": "Rectangle 24",
    width: 29.45,
    height: 16.829,
    transform: "translate(109.708 273.571) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-2",
    "data-name": "Rectangle 25",
    width: 29.45,
    height: 16.829,
    transform: "translate(13.323 290.168)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26-2",
    "data-name": "Rectangle 26",
    width: 29.45,
    height: 16.829,
    transform: "translate(109.708 306.997) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-2",
    "data-name": "Rectangle 27",
    width: 29.45,
    height: 16.829,
    transform: "translate(13.323 323.366)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28-2",
    "data-name": "Rectangle 28",
    width: 29.45,
    height: 16.829,
    transform: "translate(109.708 340.195) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29-2",
    "data-name": "Rectangle 29",
    width: 68.717,
    height: 8.414,
    transform: "translate(134.645 281.565)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-2",
    "data-name": "Rectangle 30",
    width: 68.717,
    height: 8.414,
    transform: "translate(134.645 294.363)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-2",
    "data-name": "Rectangle 31",
    width: 68.717,
    height: 8.414,
    transform: "translate(134.645 306.787)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-2",
    "data-name": "Rectangle 32",
    width: 68.717,
    height: 8.414,
    transform: "translate(315.275 285.831)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-2",
    "data-name": "Rectangle 33",
    width: 68.717,
    height: 8.414,
    transform: "translate(315.275 298.629)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34-2",
    "data-name": "Rectangle 34",
    width: 68.717,
    height: 8.414,
    transform: "translate(315.275 311.079)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35-2",
    "data-name": "Rectangle 35",
    width: 68.717,
    height: 8.414,
    transform: "translate(134.645 319.664)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36-2",
    "data-name": "Rectangle 36",
    width: 68.717,
    height: 8.414,
    transform: "translate(134.645 332.54)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37-2",
    "data-name": "Rectangle 37",
    width: 68.717,
    height: 8.414,
    transform: "translate(134.645 345.416)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38-2",
    "data-name": "Rectangle 38",
    width: 18.932,
    height: 24.542,
    transform: "translate(229.059 193.491)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39-2",
    "data-name": "Rectangle 39",
    width: 18.932,
    height: 24.542,
    transform: "translate(289.604 218.033) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40-2",
    "data-name": "Rectangle 40",
    width: 18.932,
    height: 24.542,
    transform: "translate(229.059 233.327)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41-2",
    "data-name": "Rectangle 41",
    width: 18.932,
    height: 24.542,
    transform: "translate(289.604 257.869) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42-2",
    "data-name": "Rectangle 42",
    width: 18.932,
    height: 24.542,
    transform: "translate(229.059 273.163)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43-2",
    "data-name": "Rectangle 43",
    width: 18.932,
    height: 24.542,
    transform: "translate(289.604 297.705) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44-2",
    "data-name": "Rectangle 44",
    width: 18.932,
    height: 24.542,
    transform: "translate(229.059 312.748)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45-2",
    "data-name": "Rectangle 45",
    width: 18.932,
    height: 24.542,
    transform: "translate(289.604 337.29) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46-2",
    "data-name": "Rectangle 46",
    width: 25.243,
    height: 32.255,
    transform: "translate(394.827 58.52)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47-2",
    "data-name": "Rectangle 47",
    width: 25.243,
    height: 32.255,
    transform: "translate(394.827 106.73)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48-2",
    "data-name": "Rectangle 48",
    width: 25.243,
    height: 32.255,
    transform: "translate(394.827 153.691)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49-2",
    "data-name": "Rectangle 49",
    width: 25.243,
    height: 32.255,
    transform: "translate(394.827 200.652)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50-2",
    "data-name": "Rectangle 50",
    width: 25.243,
    height: 32.255,
    transform: "translate(394.827 247.614)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51-2",
    "data-name": "Rectangle 51",
    width: 25.243,
    height: 32.255,
    transform: "translate(394.827 294.248)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52-2",
    "data-name": "Rectangle 52",
    width: 93.961,
    height: 27.347,
    transform: "translate(475.899 126.633)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53-2",
    "data-name": "Rectangle 53",
    width: 93.961,
    height: 27.347,
    transform: "translate(476.25 186.393)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54-2",
    "data-name": "Rectangle 54",
    width: 93.961,
    height: 27.347,
    transform: "translate(476.601 246.153)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55-2",
    "data-name": "Rectangle 55",
    width: 93.961,
    height: 27.347,
    transform: "translate(476.951 305.631)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56-2",
    "data-name": "Rectangle 56",
    width: 12.622,
    height: 26.646,
    transform: "translate(21.036 69.007)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57-2",
    "data-name": "Rectangle 57",
    width: 31.554,
    height: 40.669,
    transform: "translate(642.434 193.589)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58-2",
    "data-name": "Rectangle 58",
    width: 31.554,
    height: 40.669,
    transform: "translate(642.434 253.375)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59-2",
    "data-name": "Rectangle 59",
    width: 31.554,
    height: 40.669,
    transform: "translate(642.434 313.004)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15-2",
    "data-name": "Group 15",
    transform: "translate(280.711 233.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-3",
    "data-name": "Path 29",
    d: "M160.087,585.469s-34.109,20.579,28.767,52.262c0,0,13.864-25.717-1.464-46.687a20.649,20.649,0,0,0-26.787-5.87Z",
    transform: "translate(-150.851 -495.102)",
    fill: "#01a09b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-3",
    "data-name": "Path 30",
    d: "M173.08,588.3s29.188,22.334,28.373,52.7",
    transform: "translate(-162.967 -498.367)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-3",
    "data-name": "Path 31",
    d: "M236.726,561.074s-10.688-36.289,2.006-63a57.3,57.3,0,0,0,4.636-35.959,96.4,96.4,0,0,0-5.091-16.9",
    transform: "translate(-196.521 -417.276)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-3",
    "data-name": "Path 32",
    d: "M242.925,395.529c0,4.449-8.054,17.33-8.054,17.33s-8.054-12.9-8.054-17.33a8.054,8.054,0,1,1,16.1,0Z",
    transform: "translate(-193.297 -387.289)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-3",
    "data-name": "Path 33",
    d: "M273.586,447.125c-2.417,3.734-16.186,10.181-16.186,10.181s.251-15.2,2.669-18.937a8.054,8.054,0,0,1,13.517,8.752Z",
    transform: "translate(-210.552 -413.838)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34-2",
    "data-name": "Path 34",
    d: "M268.41,540.4c-3.973,2-19.11.62-19.11.62s7.889-13,11.862-15a8.053,8.053,0,1,1,7.253,14.381Z",
    transform: "translate(-205.972 -464.26)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-2",
    "data-name": "Path 35",
    d: "M251.334,614.623c-3.574,2.643-18.734,3.839-18.734,3.839s5.58-14.141,9.154-16.788a8.054,8.054,0,1,1,9.579,12.95Z",
    transform: "translate(-196.553 -506.015)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36-2",
    "data-name": "Path 36",
    d: "M215,470.388c3.189,3.1,18.053,6.308,18.053,6.308s-3.639-14.761-6.828-17.863A8.054,8.054,0,1,0,215,470.384Z",
    transform: "translate(-185.171 -425.884)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37-2",
    "data-name": "Path 37",
    d: "M193.11,554.687c3.973,2,19.11.619,19.11.619s-7.889-13-11.862-15a8.053,8.053,0,1,0-7.253,14.381Z",
    transform: "translate(-171.771 -472.228)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38-2",
    "data-name": "Path 38",
    d: "M187.183,641.783c3.574,2.643,18.734,3.838,18.734,3.838s-5.58-14.146-9.159-16.788a8.054,8.054,0,1,0-9.579,12.95Z",
    transform: "translate(-169.086 -520.444)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39-2",
    "data-name": "Path 39",
    d: "M242.925,395.529c0,4.449-8.054,17.33-8.054,17.33s-8.054-12.9-8.054-17.33a8.054,8.054,0,1,1,16.1,0Z",
    transform: "translate(-193.297 -387.289)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-2",
    "data-name": "Path 40",
    d: "M273.586,447.125c-2.417,3.734-16.186,10.181-16.186,10.181s.251-15.2,2.669-18.937a8.054,8.054,0,0,1,13.517,8.752Z",
    transform: "translate(-210.552 -413.838)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41-2",
    "data-name": "Path 41",
    d: "M268.41,540.4c-3.973,2-19.11.62-19.11.62s7.889-13,11.862-15a8.053,8.053,0,1,1,7.253,14.381Z",
    transform: "translate(-205.972 -464.26)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42-2",
    "data-name": "Path 42",
    d: "M251.334,614.623c-3.574,2.643-18.734,3.839-18.734,3.839s5.58-14.141,9.154-16.788a8.054,8.054,0,1,1,9.579,12.95Z",
    transform: "translate(-196.553 -506.015)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43-2",
    "data-name": "Path 43",
    d: "M215,470.388c3.189,3.1,18.053,6.308,18.053,6.308s-3.639-14.761-6.828-17.863A8.054,8.054,0,1,0,215,470.384Z",
    transform: "translate(-185.171 -425.884)",
    fill: "#5ec5c1",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44-2",
    "data-name": "Path 44",
    d: "M193.11,554.687c3.973,2,19.11.619,19.11.619s-7.889-13-11.862-15a8.053,8.053,0,1,0-7.253,14.381Z",
    transform: "translate(-171.771 -472.228)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45-2",
    "data-name": "Path 45",
    d: "M187.183,641.783c3.574,2.643,18.734,3.838,18.734,3.838s-5.58-14.146-9.159-16.788a8.054,8.054,0,1,0-9.579,12.95Z",
    transform: "translate(-169.086 -520.444)",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16-2",
    "data-name": "Group 16",
    transform: "translate(453.616 184.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-3",
    "data-name": "Path 46",
    d: "M1008.187,578.286s-14.271-48.455,2.679-84.119a76.515,76.515,0,0,0,6.19-48.015,128.721,128.721,0,0,0-6.8-22.561",
    transform: "translate(-974.457 -386.005)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-3",
    "data-name": "Path 47",
    d: "M1018.416,376.663c0,5.941-10.754,23.14-10.754,23.14s-10.754-17.222-10.754-23.14a10.754,10.754,0,1,1,21.5,0Z",
    transform: "translate(-972.069 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-3",
    "data-name": "Path 48",
    d: "M1049.063,429.277c-3.228,4.987-21.613,13.595-21.613,13.595s.336-20.3,3.564-25.286a10.754,10.754,0,1,1,18.049,11.686Z",
    transform: "translate(-984.944 -384.833)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-3",
    "data-name": "Path 49",
    d: "M1044.878,523.878c-5.305,2.673-25.518.827-25.518.827s10.534-17.355,15.839-20.028a10.753,10.753,0,1,1,9.685,19.2Z",
    transform: "translate(-981.534 -422.206)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-3",
    "data-name": "Path 50",
    d: "M1027.674,597.864c-4.773,3.529-25.014,5.125-25.014,5.125s7.451-18.882,12.224-22.417a10.754,10.754,0,1,1,12.791,17.292Z",
    transform: "translate(-974.495 -452.836)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-3",
    "data-name": "Path 51",
    d: "M986.044,453.543c4.258,4.136,24.106,8.423,24.106,8.423s-4.859-19.709-9.117-23.852a10.755,10.755,0,1,0-14.989,15.429Z",
    transform: "translate(-966.117 -394.129)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-3",
    "data-name": "Path 52",
    d: "M964.866,538.257c5.3,2.673,25.518.827,25.518.827s-10.535-17.355-15.84-20.028a10.754,10.754,0,0,0-9.678,19.2Z",
    transform: "translate(-956.173 -428.143)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-3",
    "data-name": "Path 53",
    d: "M958.333,625.024c4.773,3.529,25.014,5.126,25.014,5.126s-7.451-18.882-12.224-22.417a10.754,10.754,0,1,0-12.791,17.292Z",
    transform: "translate(-953.974 -463.951)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17-2",
    "data-name": "Group 17",
    transform: "translate(255.609 251.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54-2",
    "data-name": "Path 54",
    d: "M902.49,639.921s9.3-31.554-1.746-54.792a49.85,49.85,0,0,1-4.032-31.273,83.841,83.841,0,0,1,4.425-14.676",
    transform: "translate(-879.61 -514.446)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55-2",
    "data-name": "Path 55",
    d: "M892.72,515.242c0,3.871,7.012,15.083,7.012,15.083s7.012-11.219,7.012-15.083a7.012,7.012,0,1,0-14.024,0Z",
    transform: "translate(-878.058 -508.23)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56-2",
    "data-name": "Path 56",
    d: "M910.456,544.065c2.1,3.247,14.08,8.856,14.08,8.856s-.217-13.225-2.321-16.471a7.012,7.012,0,1,0-11.759,7.615Z",
    transform: "translate(-907.371 -515.294)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57-2",
    "data-name": "Path 57",
    d: "M908.39,595.407c3.457,1.739,16.625.54,16.625.54s-6.865-11.3-10.315-13.042a7.012,7.012,0,0,0-6.311,12.509Z",
    transform: "translate(-904.8 -529.403)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58-2",
    "data-name": "Path 58",
    d: "M898.393,635.089c3.113,2.3,16.3,3.338,16.3,3.338s-4.852-12.3-7.965-14.6a7.012,7.012,0,0,0-8.33,11.261Z",
    transform: "translate(-888.177 -539.386)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59-2",
    "data-name": "Path 59",
    d: "M900.5,557.266c-2.8,2.693-15.7,5.49-15.7,5.49s3.162-12.839,5.939-15.532a7.012,7.012,0,1,1,9.761,10.048Z",
    transform: "translate(-868.633 -518.746)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60-2",
    "data-name": "Path 60",
    d: "M889.226,603.1c-3.457,1.739-16.625.54-16.625.54s6.865-11.3,10.315-13.042a7.012,7.012,0,0,1,6.311,12.51Z",
    transform: "translate(-850.022 -531.59)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61-2",
    "data-name": "Path 61",
    d: "M886.273,649.681c-3.113,2.3-16.3,3.338-16.3,3.338s4.88-12.306,7.966-14.606a7.012,7.012,0,0,1,8.33,11.268Z",
    transform: "translate(-844.264 -543.734)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_28-2",
    "data-name": "Path 28",
    d: "M366.145,154.551H361.32a3.38,3.38,0,1,0,0-6.753H322.242a3.38,3.38,0,0,0,0,6.753h4.824a3.38,3.38,0,1,0,0,6.753h-6.753a3.38,3.38,0,1,0,0,6.753h39.078a3.38,3.38,0,1,0,0-6.753h6.753a3.38,3.38,0,1,0,0-6.753Z",
    transform: "translate(-179.147 -121.118)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-4",
    "data-name": "Path 29",
    d: "M612.145,275.551H607.32a3.38,3.38,0,1,0,0-6.753H568.242a3.38,3.38,0,0,0,0,6.753h4.824a3.38,3.38,0,1,0,0,6.753h-6.752a3.38,3.38,0,1,0,0,6.753h39.078a3.38,3.38,0,1,0,0-6.753h6.753a3.38,3.38,0,1,0,0-6.753Z",
    transform: "translate(-251.597 -155.671)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-4",
    "data-name": "Path 30",
    d: "M1031.145,117.551h-4.824a3.38,3.38,0,1,0,0-6.753H987.243a3.38,3.38,0,0,0,0,6.753h4.824a3.38,3.38,0,1,0,0,6.753h-6.753a3.38,3.38,0,1,0,0,6.753h39.078a3.38,3.38,0,0,0,0-6.753h6.753a3.38,3.38,0,1,0,0-6.753Z",
    transform: "translate(-374.911 -110.062)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-4",
    "data-name": "Path 31",
    d: "M519.714,465.94c-.54.393-.834.61-.834.61A3.551,3.551,0,0,0,519.714,465.94Z",
    transform: "translate(-238.823 -212.737)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-4",
    "data-name": "Path 32",
    d: "M520.645,466.88c-.54.393-.835.61-.835.61A3.561,3.561,0,0,0,520.645,466.88Z",
    transform: "translate(-239.097 -213.009)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-4",
    "data-name": "Path 33",
    d: "M520.645,465.94c-.54.393-.835.61-.835.61A3.556,3.556,0,0,0,520.645,465.94Z",
    transform: "translate(-239.097 -212.737)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18-2",
    "data-name": "Group 18",
    transform: "translate(411.191 246.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-4",
    "data-name": "Path 46",
    d: "M1009.55,528.181s9.649-32.761-1.811-56.874a51.731,51.731,0,0,1-4.185-32.464,87.039,87.039,0,0,1,4.6-15.254",
    transform: "translate(-985.525 -398.178)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-4",
    "data-name": "Path 47",
    d: "M996.9,373.1c0,4.017,7.271,15.645,7.271,15.645s7.271-11.644,7.271-15.645a7.271,7.271,0,1,0-14.538,0Z",
    transform: "translate(-981.411 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-4",
    "data-name": "Path 48",
    d: "M1028.719,423.827c2.182,3.372,14.613,9.192,14.613,9.192s-.227-13.725-2.409-17.1a7.271,7.271,0,1,0-12.2,7.9Z",
    transform: "translate(-1025.24 -393.777)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-4",
    "data-name": "Path 49",
    d: "M1023.363,517.285c3.587,1.807,17.253.559,17.253.559s-7.122-11.734-10.709-13.541a7.27,7.27,0,1,0-6.548,12.983Z",
    transform: "translate(-1019.36 -448.543)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-4",
    "data-name": "Path 50",
    d: "M1005.607,591.581c3.227,2.386,16.912,3.465,16.912,3.465s-5.038-12.766-8.264-15.156a7.271,7.271,0,1,0-8.648,11.691Z",
    transform: "translate(-994.733 -493.526)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-4",
    "data-name": "Path 51",
    d: "M999.081,447.561c-2.879,2.8-16.3,5.695-16.3,5.695s3.286-13.326,6.164-16.126a7.272,7.272,0,1,1,10.134,10.431Z",
    transform: "translate(-965.724 -407.39)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-4",
    "data-name": "Path 52",
    d: "M976.444,531.7c-3.587,1.807-17.252.559-17.252.559s7.122-11.734,10.709-13.541a7.271,7.271,0,0,1,6.543,12.982Z",
    transform: "translate(-935.492 -457.254)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-4",
    "data-name": "Path 53",
    d: "M970.886,618.741c-3.227,2.386-16.912,3.465-16.912,3.465s5.038-12.766,8.265-15.156a7.271,7.271,0,1,1,8.648,11.691Z",
    transform: "translate(-927.004 -509.838)",
    fill: "#017572"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginRegisterBuilding);
export default __webpack_public_path__ + "static/media/login_register_building.e542ff18aa7620c32d608b802ed9fe51.svg";
export { ForwardRef as ReactComponent };